export default "__VITE_ASSET__s6BWZaaO__"